import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { API } from "../context/AuthContext";
import { AlertTriangle } from "lucide-react";

// PayPal button for PRO plans: the order (with VAT) is created server-side, captured server-side.
export default function PayPalCheckout({ plan, couponCode, disabled }) {
  const [cfg, setCfg] = useState(null);
  const nav = useNavigate();
  useEffect(() => { axios.get(`${API}/paypal/config`).then(({ data }) => setCfg(data)).catch(() => setCfg({ configured: false })); }, []);
  if (!cfg) return null;
  if (!cfg.configured) return (
    <div className="mt-3 text-[11px] font-mono-rl tracking-widest uppercase text-slate-500 flex items-center gap-2" data-testid={`paypal-not-configured-${plan.code.toLowerCase()}`}>
      <AlertTriangle className="w-3 h-3 text-[#FF9F0A]" />PayPal · non disponibile
    </div>
  );
  return (
    <div className="mt-3" data-testid={`paypal-wrapper-${plan.code.toLowerCase()}`}>
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "EUR", intent: "capture" }}>
        <PayPalButtons disabled={disabled} style={{ layout: "horizontal", color: "gold", shape: "rect", label: "paypal", height: 42, tagline: false }}
          createOrder={async () => {
            try { const { data } = await axios.post(`${API}/paypal/orders`, { plan_code: plan.code, coupon_code: couponCode || null, origin_url: window.location.origin }); sessionStorage.setItem("rl_pp_order", data.payment_id); return data.order_id; }
            catch (e) { toast.error(e.response?.data?.detail || "Ordine PayPal non riuscito"); throw e; }
          }}
          onApprove={async (data) => {
            try {
              const res = await axios.post(`${API}/paypal/orders/${data.orderID}/capture`);
              if (res.data.status === "COMPLETED") nav(`/payment/success?order_id=${res.data.payment_id}`);
              else nav(`/payment/cancel?order_id=${res.data.payment_id}&failed=1`);
            } catch (e) { toast.error(e.response?.data?.detail || "Conferma pagamento non riuscita"); const pid = sessionStorage.getItem("rl_pp_order"); if (pid) nav(`/payment/cancel?order_id=${pid}&failed=1`); }
          }}
          onCancel={() => { const pid = sessionStorage.getItem("rl_pp_order"); nav(pid ? `/payment/cancel?order_id=${pid}` : "/payment/cancel"); }}
          onError={() => { toast.error("PayPal non disponibile. Riprova o usa la carta."); }}
        />
      </PayPalScriptProvider>
    </div>
  );
}
